// extracted by mini-css-extract-plugin
var _1 = "AvatarStack-module__animatedBackground--HM0ct";
var _2 = "AvatarStack-module__buttonCount--jYj5r";
var _3 = "AvatarStack-module__circle--L2mfB";
var _4 = "AvatarStack-module__container--zMgYa";
var _5 = "AvatarStack-module__count--YxjYK";
var _6 = "AvatarStack-module__countContent--PZ9Z0";
var _7 = "AvatarStack-module__noWrap--YEE2R";
var _8 = "AvatarStack-module__plus--WdQUn";
var _9 = "AvatarStack-module__smallPill--BOPKJ";
var _a = "AvatarStack-module__tight--T2rND";
var _b = "AvatarStack-module__withCutOut--Rb9A5";
export { _1 as "animatedBackground", _2 as "buttonCount", _3 as "circle", _4 as "container", _5 as "count", _6 as "countContent", _7 as "noWrap", _8 as "plus", _9 as "smallPill", _a as "tight", _b as "withCutOut" }
